/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import * as moment from 'moment';

import {MonthView, MonthViewDay, WeekDay} from '../../../../models/time-and-attendance.interfaces';
import {
  addDays,
  differenceInDays,
  endOfMonth,
  endOfWeekOn,
  getDay,
  isSameDay,
  isSameMonth,
  startOfDay,
  startOfWeekOn
} from '../../../../shared/utils/date';

const WEEKEND_DAY_NUMBERS: number[] = [0, 6];
const DAYS_IN_WEEK: number = 7;

export class CalendarUtils {

  public static getWeekDay(date: Date): WeekDay {
    const today: Date = startOfDay(new Date());
    return {
      date,
      isPast: date < today,
      isToday: isSameDay(date, today),
      isFuture: date > today,
      isWeekend: WEEKEND_DAY_NUMBERS.indexOf(getDay(date)) > -1,
      dayOfWeek: getDay(date)
    };
  }

  public static getMonthView(viewDate: Date): MonthView {
    const start = moment(moment(viewDate).startOf('month')).startOf('isoWeek').toDate();
    const end = endOfWeekOn(endOfMonth(viewDate), 1);

    const days: MonthViewDay[] = [];
    for (let i: number = 0; i < differenceInDays(end, start) + 1; i++) {
      const date: Date = addDays(start, i);
      const day: MonthViewDay = this.getWeekDay(date) as MonthViewDay;
      day.inMonth = isSameMonth(date, viewDate);
      days.push(day);
    }

    const rows: number = Math.floor(days.length / 7);
    const rowOffsets: number[] = [];
    for (let i: number = 0; i < rows; i++) {
      rowOffsets.push(i * 7);
    }

    return {
      rowOffsets,
      days
    };
  }

  public static getWeekViewHeader(viewDate: Date): WeekDay[] {
    const start: Date = startOfWeekOn(viewDate, 1);
    const days: WeekDay[] = [];
    for (let i: number = 0; i < DAYS_IN_WEEK; i++) {
      const date: Date = addDays(start, i);
      days.push(this.getWeekDay(date));
    }
    return days;
  }
}
